import graphqlClient from "../../../apollo";

class ProductoProvider {

    findProducto(id) {
        return graphqlClient.query({
            query: require('./gql/productoFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    findPreciosProveedor(productoId) {
        return graphqlClient.query({
            query: require('./gql/productoPreciosProveedor.graphql'),
            variables: { productoId },
            fetchPolicy: "network-only"
        })
    }

    upsertProductoProveedorPrecio(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoProveedorPrecioUpsert.graphql'),
            variables: { input }
        })
    }

    eliminarProductoProveedorPrecio(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoProveedorPrecioEliminar.graphql'),
            variables: { id }
        })
    }

    fetchProductos() {
        return graphqlClient.query({ 
            query: require('./gql/productoFetch.graphql'),
            fetchPolicy: "network-only"
         })
    }

    paginateProductos(pageNumber, itemsPerPage, search = null, filters, orderBy = null, orderDesc = false, listaPreciosId = null) {
        return graphqlClient.query({
            query: require('./gql/productoPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, filters, orderBy, orderDesc, listaPreciosId },
            fetchPolicy: "network-only"
        })
    }

    findByParamsProducto(codigoBarras, depositoId = null) {
        return graphqlClient.query({
            query: require('./gql/productoFindByParams.graphql'),
            variables: { codigoBarras, depositoId },
            fetchPolicy: "network-only"
        })
    }

    searchProductosByMarcaModelo(searchText, depositoId = null) {
        return graphqlClient.query({
            query: require('./gql/productoSearchByMarcaModelo.graphql'),
            variables: { searchText, depositoId },
            fetchPolicy: "network-only"
        })
    }

    createProducto(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoCreate.graphql'),
            variables: form
        })
    }

    addProductoToCsv(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/addProductoToCsv.graphql'),
            variables: form
        })
    }

    updateProducto(form) {
        const variables = { ...form }
        // Enviar null para limpiar referencias; omitir la variable (delete) hace que el backend no actualice y deje el valor guardado.
        ;['marca', 'modelo', 'tamanio'].forEach((key) => {
            const v = variables[key]
            if (v == null) {
                variables[key] = null
                return
            }
            if (typeof v === 'object' && !Array.isArray(v)) {
                const oid = v.id || v._id
                if (!oid) {
                    variables[key] = null
                }
            }
        })
        if (form.productoProveedorPrecioActivoId != null && form.descuentoProveedor != null && form.descuentoProveedor !== '') {
            variables.activePppDescuentoProveedor = Number(form.descuentoProveedor)
        }
        return graphqlClient.mutate({
            mutation: require('./gql/productoUpdate.graphql'),
            variables
        })
    }

    productoUpdateManyPrecio(filters, porcentaje) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoUpdateManyPrecio.graphql'),
            variables: { filters, porcentaje }
        })
    }

    productoUpdateManyPrecioFijo(filters, montoFijo) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoUpdateManyPrecioFijo.graphql'),
            variables: { filters, montoFijo }
        })
    }

    productoUpdateManyStock(itemIds, stock) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoUpdateManyStock.graphql'),
            variables: { itemIds, stock }
        })
    }

    deleteProducto(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoDelete.graphql'),
            variables: { id }
        })
    }

    transferirStock(transferencias) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoTransferirStock.graphql'),
            variables: { transferencias }
        })
    }

    productoAgregarStock(agregados) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoAgregarStock.graphql'),
            variables: { agregados }
        })
    }

    updateManyPricing(productos) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoUpdateManyPricing.graphql'),
            variables: { productos }
        })
    }

    productoUpdateManyAtributos(ids, input) {
        return graphqlClient.mutate({
            mutation: require('./gql/productoUpdateManyAtributos.graphql'),
            variables: { ids, input }
        })
    }

}

export default new ProductoProvider()


